import { createSteeringURL } from '@/api'
import { components } from '@/steering-types'
import { steeringAuthInit } from '@/stores/auth'
import { KeysFrom, Show } from '@/types'
import { aggregateWithIdsParameter, useStoreHelpers } from '@/util/api'
import {
  APICreate,
  APIListPaginated,
  APIRemove,
  APIRetrieve,
  APIUpdate,
  createExtendableAPI,
} from '@rokoli/bnb/drf'
import { defineStore } from 'pinia'

type ReadonlyAttrs = KeysFrom<
  Show,
  'id' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy' | '_meta'
>
type ShowCreateData = Omit<
  Show,
  | ReadonlyAttrs
  | 'slug'
  | 'firstBroadcastAt'
  | 'lastBroadcastAt'
  | 'defaultMediaId'
  | 'involvedPeopleCount'
  | 'storageQuotaMib'
> & { slug?: string }
type ShowUpdateData = ShowCreateData
type ShowPartialUpdateData = components['schemas']['PatchedShow']
export type NewShow = ShowCreateData

export function newShow(): NewShow {
  return {
    name: '',
    description: '',
    shortDescription: '',
    email: '',
    internalNote: '',
    typeId: -1,
    fundingCategoryId: -1,
    isActive: true,
    isPublic: true,
    predecessorId: null,
    cbaSeriesId: null,
    imageId: null,
    logoId: null,
    links: [],
    topicIds: [],
    categoryIds: [],
    musicFocusIds: [],
    ownerIds: [],
    hostIds: [],
    languageIds: [],
  }
}

export const useShowStore = defineStore('shows', () => {
  const endpoint = createSteeringURL.prefix('shows')
  const { api, base } = createExtendableAPI<Show>(endpoint, steeringAuthInit)
  const listOperations = APIListPaginated(api)
  const retrieveOperations = APIRetrieve(api, {
    aggregate: aggregateWithIdsParameter(listOperations.listIsolated),
  })

  return {
    ...base,
    ...listOperations,
    ...retrieveOperations,
    ...APICreate<Show, ShowCreateData>(api),
    ...APIUpdate<Show, ShowUpdateData, ShowPartialUpdateData>(api),
    ...APIRemove(api),
    ...useStoreHelpers({ ...base, ...listOperations, ...retrieveOperations }),
  }
})
